import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { PreCashinInfo } from '../../../../../../../types/Cashier';
import { Messages, getBonusMessage } from '../../../../../../../utils/bonus';

import EligibleDepositsLeft from './components/EligibleDepositsLeft/EligibleDepositsLeft';

interface Props {
  isSingleTicket: boolean;
}

const TicketsInfo: React.FC<Props> = ({ isSingleTicket }) => {
  const {
    data: { preCashinInfo }
  } = useWizardContext();

  const { amountReleasePortion, bonusCurrency, maxNumTickets, ticketReleasePortion } =
    preCashinInfo as PreCashinInfo;

  return (
    <>
      <Translation
        tagName="p"
        {...getBonusMessage(Messages.TicketsDetails, isSingleTicket, maxNumTickets === 1)}
        values={{
          0: maxNumTickets
        }}
      />
      {!!amountReleasePortion && (
        <Translation
          tagName="p"
          {...getBonusMessage(Messages.PortionAmount, isSingleTicket, ticketReleasePortion === 1)}
          values={{
            0: <CurrencyAmount value={amountReleasePortion} currency={bonusCurrency} />,
            1: ticketReleasePortion
          }}
        />
      )}
      <EligibleDepositsLeft isSingleTicket={isSingleTicket} />
    </>
  );
};

export default TicketsInfo;
